import { getDeviceInfo } from './getDeviceInfo';
var isPc;
export function isPcPlatform() {
    if (isPc === undefined) {
        isPc = getDeviceInfo().platform.platformType === "PC" /* PlatformType.PC */;
    }
    return isPc;
}
//# sourceMappingURL=isPcPlatform.js.map